// src/pages/coach/sessions/AttendanceMark.jsx
import React from "react";
import MarkAttendance from "../../../components/attendance/MarkAttendance";

const CoachAttendanceMark = () => {
    return <MarkAttendance role="COACH" />;
};

export default CoachAttendanceMark;
